import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Separator from '../components/Separator';
import FeaturedSolutions, { FeaturedItem } from '../components/FeaturedSolutions';
import pcGolfSheet from '../assets/products/pc-golf-sheet.png';
import appGolfBooking from '../assets/products/app-golf-booking.png';
import pcGolfRetail from '../assets/products/pc-golf-retail.png';

const ShopPage = () => {
  const navigate = useNavigate();

  return (
    <div className="page shopPage">
      <Header />
      <div className="page-header">Golf Course</div>

      <div className="text-wrapper">
        <div className="top">
          <div className="topic-header">Pro Shop</div>
          <Separator />
        </div>
        <div className="std-text">
          {"Ensure that you always have the perfect sleeve of balls or logoed golf wear for every golfer.\n\n"}
        </div>
        <div className="std-text">
          {"With InfoGenesis POS and Agilysys Eatec procurement and perpetual inventory system, not only will you have the items your guests desire, but they can also seamlessly pay with credit cards, gift cards or cash."}
        </div>
      </div>

      <FeaturedSolutions>
        <FeaturedItem
          label="Golf"
          imgSrc={pcGolfSheet}
          onClick={() => navigate('/solutions/golf')}
        />
        <FeaturedItem
          label="Book"
          imgSrc={appGolfBooking}
          onClick={() => navigate('/solutions/book')}
        />
        <FeaturedItem
          label="Retail"
          imgSrc={pcGolfRetail}
          onClick={() => navigate('/solutions/retail')}
        />
      </FeaturedSolutions>
    </div>
  );
};

export default ShopPage;
